var map = {
	"./kubewarden": "1a40",
	"./kubewarden/": "1a40",
	"./kubewarden/admission": "f0e8",
	"./kubewarden/admission/": "f0e8",
	"./kubewarden/admission/General": "ff83",
	"./kubewarden/admission/General.vue": "ff83",
	"./kubewarden/admission/Rule": "3c2a",
	"./kubewarden/admission/Rule.vue": "3c2a",
	"./kubewarden/admission/Rules": "6f31",
	"./kubewarden/admission/Rules.vue": "6f31",
	"./kubewarden/admission/index": "f0e8",
	"./kubewarden/admission/index.vue": "f0e8",
	"./kubewarden/index": "1a40",
	"./kubewarden/index.vue": "1a40",
	"./kubewarden/policy-server": "b118",
	"./kubewarden/policy-server/": "b118",
	"./kubewarden/policy-server/General": "d8b3",
	"./kubewarden/policy-server/General.vue": "d8b3",
	"./kubewarden/policy-server/Labels": "a583",
	"./kubewarden/policy-server/Labels.vue": "a583",
	"./kubewarden/policy-server/Registry/Authority": "22a0",
	"./kubewarden/policy-server/Registry/Authority.vue": "22a0",
	"./kubewarden/policy-server/Registry/Index": "6b48",
	"./kubewarden/policy-server/Registry/Index.vue": "6b48",
	"./kubewarden/policy-server/Registry/SourceAuthorities": "3c82",
	"./kubewarden/policy-server/Registry/SourceAuthorities.vue": "3c82",
	"./kubewarden/policy-server/Verification": "3db8",
	"./kubewarden/policy-server/Verification.vue": "3db8",
	"./kubewarden/policy-server/index": "b118",
	"./kubewarden/policy-server/index.vue": "b118"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5ea7";